import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { api } from '../services/api';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const code = hashParams.get('code');
    const error = hashParams.get('error') || searchParams.get('error');

    if (error) {
      navigate(`/login?error=${encodeURIComponent(error)}`);
      return;
    }

    if (!code) {
      navigate('/login?error=Invalid+authentication+response');
      return;
    }

    let cancelled = false;

    api.post('/login/google/exchange', { code })
      .then((response) => {
        if (cancelled) {
          return;
        }
        const token = response.data?.data?.token;
        if (!token) {
          navigate('/login?error=Invalid+authentication+response');
          return;
        }
        localStorage.setItem('token', token);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        window.history.replaceState(null, '', window.location.pathname);
        window.location.href = '/';
      })
      .catch(() => {
        if (!cancelled) {
          navigate('/login?error=Sign-in+code+expired.+Please+try+again.');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1" color="text.secondary">
        Completing sign in…
      </Typography>
    </Box>
  );
};

export default AuthCallback;
